<template>
    <h2
        :class="classStyles['text-main_color-500']"
        class="text-2xl md:text-3xl"
    >
        <slot/>
    </h2>
</template>

<script>
export default {
  name: 'BaseH2',
  data () {
    return {
      classStyles: window.class_styles
    }
  }
}
</script>

<style scoped>

</style>
